import template from './balconies-count.jade';

export default angular
    .module('cian.addForm.balconiesCount', [])
    .directive('cianAfAboutObjectBalconiesCount', () => ({
        scope: {},
        bindToController: {
            ad: '=',
            form: '=',
        },
        controller(deviceService) {
            'ngInject';

            this.isMobile = deviceService.isMobile;

            this.items = [{
                value: undefined,
                text: 'Нет',
            }, ...[1, 2, 3, 4].map(n => ({ value: n, text: n }))];

            if (!this.ad.balconiesCount) {
                this.ad.balconiesCount = this.items[0].value;
            }
        },
        controllerAs: 'balconiesCount',
        template,
    }))
    .name;
